"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var ReactDOM = __importStar(require("react-dom"));
var react_rnd_1 = require("react-rnd");
var MultiEditor_1 = __importDefault(require("../MultiEditor/MultiEditor"));
require("./SymbolizerEditorWindow.css");
var antd_1 = require("antd");
var LocaleWrapper_1 = require("../../LocaleWrapper/LocaleWrapper");
var en_US_1 = __importDefault(require("../../../locale/en_US"));
var _isEqual = require('lodash/isEqual');
/**
 * Symbolizer editorwindow UI.
 */
var SymbolizerEditorWindow = /** @class */ (function (_super) {
    __extends(SymbolizerEditorWindow, _super);
    function SymbolizerEditorWindow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SymbolizerEditorWindow.prototype.shouldComponentUpdate = function (nextProps) {
        return !_isEqual(this.props, nextProps);
    };
    SymbolizerEditorWindow.prototype.render = function () {
        var _a = this.props, x = _a.x, y = _a.y, onClose = _a.onClose, symbolizers = _a.symbolizers, onSymbolizersChange = _a.onSymbolizersChange, locale = _a.locale, internalDataDef = _a.internalDataDef, iconLibraries = _a.iconLibraries, constrainWindow = _a.constrainWindow, colorRamps = _a.colorRamps;
        return (ReactDOM.createPortal(React.createElement(react_rnd_1.Rnd, { bounds: constrainWindow, className: "symbolizer-editor-window", default: {
                x: x || window.innerWidth / 2,
                y: y || window.innerHeight / 2,
                width: undefined,
                height: undefined
            }, enableResizing: {
                bottom: false,
                bottomLeft: false,
                bottomRight: false,
                left: false,
                right: false,
                top: false,
                topLeft: false,
                topRight: false
            }, dragHandleClassName: "symbolizer-editor-window-header" },
            React.createElement("div", { className: "header symbolizer-editor-window-header" },
                React.createElement("span", { className: "title" }, locale.symbolizersEditor),
                React.createElement(antd_1.Button, { icon: "close", size: "small", onClick: onClose })),
            React.createElement(MultiEditor_1.default, { internalDataDef: internalDataDef, symbolizers: symbolizers, onSymbolizersChange: onSymbolizersChange, iconLibraries: iconLibraries, editorProps: { colorRamps: colorRamps } })), document.body));
    };
    SymbolizerEditorWindow.defaultProps = {
        locale: en_US_1.default.GsSymbolizerEditorWindow,
        constrainWindow: 'body'
    };
    SymbolizerEditorWindow.componentName = 'SymbolizerEditorWindow';
    return SymbolizerEditorWindow;
}(React.Component));
exports.SymbolizerEditorWindow = SymbolizerEditorWindow;
exports.default = LocaleWrapper_1.localize(SymbolizerEditorWindow, SymbolizerEditorWindow.componentName);
//# sourceMappingURL=SymbolizerEditorWindow.js.map